import type { SessionData } from "./session-data.types"
import { sessionTimeout } from "./session-data.types"

export function shouldCreateNewSession(
  existingSession: SessionData | null,
  now: number,
): boolean {
  return !existingSession || now - existingSession.lastActivity > sessionTimeout
}
